import type { SVGProps } from 'react';
const Svg6FtApart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#6_ft_apart_svg__a)">
      <path
        fill="currentColor"
        d="M6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 2 9.43V10h8v-.57ZM18 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 14 9.43V10h8v-.57ZM19 17v-2.01L5 15v2l-3-3 3-3v2.01L19 13v-2l3 3-3 3Zm-9 2v-1H7.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h2c.28 0 .5-.22.5-.5V20c0-.28-.22-.5-.5-.5H8V19h2Zm-1 1.5v.5H8v-.5h1Zm8.5-1.5h-1v3h-1v-3h-1v-1h3v1Zm-5 0v.5h1v1h-1V22h-1v-4H14v1h-1.5Z"
      />
    </g>
    <defs>
      <clipPath id="6_ft_apart_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Svg6FtApart;
